<!--
할당변경 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                <h4>할당변경</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <app-input-ex
                    class="uk-margin"
                    type="radio"
                    name="allocate_to"
                    v-model="allocateTo"
                    label=""
                    init-error-msg=""
                    :options="allocateToOptions"
                ></app-input-ex>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },
            /**
             * 총괄관리자 & 회원사인지 (창고제한)
             */
            onlyGeneralOrUser: {
                type: Boolean,
                default: false
            },

        },
        data: function () {
            return {
                /**
                 * (object) 커뮤니케이션 오브젝트
                 **/
                cm: null,

                /**
                 * (string) 할당
                 */
                allocateTo: null,

                /**
                 * (int) 할당 지역ID
                 *  - 값이 있어야 할당변경 옵션에 지역이 표시됨
                 */
                allocateRegionId: null,

                /**
                 * (int) 할당 사용자ID
                 *  - 값이 있어야 할당변경 옵션에 사용자가 표시됨
                 */
                allocateUserId: null,

                /**
                 * (string) 할당 사용자닉네임
                 *  - select 옵션에 닉네임이 표시됨
                 */
                allocateUserNick: null,
            };
        },
        computed: {
            /**
             * 변경가능한 select box 옵션
             * @return []
             */
            allocateToOptions() {

                const options = [];

                options.push({
                    text: '한국총괄',
                    val: 1,
                });

                if (this.allocateRegionId) {
                    options.push({
                        text: '창고',
                        val: 2,
                    });
                }

                if (this.allocateUserId) {
                    let user_text = '사용자';
                    if (this.onlyGeneralOrUser) {
                        user_text += '('+this.allocateUserNick+')';
                    }
                    options.push({
                        text: user_text,
                        val: 3,
                    });
                }

                options.push({
                    text: 'EMPTY',
                    val: 9,
                });

                return options;
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param cm_id 커뮤니케이션ID
             * @param allocate_region_id
             * @param allocate_user_id
             * @param allocate_user_nick
             */
            form(cm_id, allocate_region_id, allocate_user_id, allocate_user_nick) {
                this.allocateRegionId = allocate_region_id;
                this.allocateUserId = allocate_user_id;
                this.allocateUserNick = allocate_user_nick;


                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/communications/' + cm_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.cm = response.cm;
                    this.allocateTo = this.cm.allocate_to.toString();


                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/communications/' + this.cm.id + '/allocate',
                    data: {
                        '_token': this.csrfToken,
                        'allocate_to': this.allocateTo,
                        'allocate_region_id': this.allocateRegionId,
                        'allocate_user_id': this.allocateUserId,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>